import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=b0bdf818&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"
import style0 from "./Address.vue?vue&type=style&index=0&id=b0bdf818&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bdf818",
  null
  
)

export default component.exports